<template>
  <div class="chat-icon" @click="next()">
    <div class="chat-icon__bubble"></div>
    <div class="chat-icon__message">
      Müşteri Hizmetlerimiz sorularınızı cevaplamaya hazır 😊
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    },
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isloading: function () {
      return this.$store.getters.isLoading;
    },
  },
  methods: {
    next: function () {
      let vm = this;

      if (vm.isloading) return;

      vm.$emit("changeStep", 3);
    },
  },
};
</script>